module.exports = __webpack_public_path__ + "static/media/sync+.9dd50a10.svg";